// Central data file for George Emad's website
// Easy to update content without touching components

export const SITE_CONFIG = {
  name: "George Emad",
  role: "Tech Content Creator & Video Producer",
  tagline: "Tech Content Creator | 500K+ Audience",
  heroDescription: "A filmmaker and director with 9 years of experience in tech-focused storytelling.",
  heroImage: "https://images.unsplash.com/photo-1759074558477-6f35e3a5eb30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxkYXJrJTIwdGVjaCUyMHN0dWRpbyUyMHNldHVwJTIwbmVvbnxlbnwwfHx8fDE3NzY2MjU3MjN8MA&ixlib=rb-4.1.0&q=85",
};

export const SOCIAL_LINKS = {
  youtube: {
    url: "https://www.youtube.com/channel/UCBS-wYB_X25spPaaUb5H2jA",
    label: "YouTube",
    followers: "250K+",
  },
  youtubeShorts: {
    url: "https://www.youtube.com/@georgeemadshorts",
    label: "YouTube Shorts",
    followers: "50K+",
  },
  tiktok: {
    url: "https://www.tiktok.com/@georgeemad17",
    label: "TikTok",
    followers: "60K+",
  },
  instagram: {
    url: "https://www.instagram.com/georgeemad16/",
    label: "Instagram",
    followers: "40K+",
  },
  facebook: {
    url: "https://www.facebook.com/georgeemad.tech.channel/",
    label: "Facebook",
    followers: "15K+",
  },
};

export const FEATURED_VIDEOS = [
  {
    id: 1,
    title: "iPhone 17 Pro Max - Every Feature Before Launch",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/KPqBP0R-epU",
    thumbnail: "https://img.youtube.com/vi/KPqBP0R-epU/hqdefault.jpg",
    views: "500K+",
  },
  {
    id: 2,
    title: "Best Electric Scooter in Egypt - 60 km/h!",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/bobsozJ39Is",
    thumbnail: "https://img.youtube.com/vi/bobsozJ39Is/hqdefault.jpg",
    views: "271K",
  },
  {
    id: 3,
    title: "KUGOOKIRIN G2 PRO 2025 - Street Beast Review",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/z6kAORawg5k",
    thumbnail: "https://img.youtube.com/vi/z6kAORawg5k/hqdefault.jpg",
    views: "150K+",
  },
  {
    id: 4,
    title: "Coolest Car in the World! 2024",
    category: "Creative Ads",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/GJ-vyojX_6s",
    thumbnail: "https://img.youtube.com/vi/GJ-vyojX_6s/hqdefault.jpg",
    views: "320K+",
  },
];

// Long-form YouTube videos
export const LONG_VIDEOS = [
  {
    id: "l1",
    title: "iPhone 17 Pro Max - All Features Revealed",
    category: "Tech Reviews",
    embedUrl: "https://www.youtube.com/embed/KPqBP0R-epU",
    thumbnail: "https://img.youtube.com/vi/KPqBP0R-epU/maxresdefault.jpg",
    views: "500K+",
    duration: "15:20",
  },
  {
    id: "l2",
    title: "Best Electric Scooter in Egypt - 60 km/h!",
    category: "Tech Reviews",
    embedUrl: "https://www.youtube.com/embed/bobsozJ39Is",
    thumbnail: "https://img.youtube.com/vi/bobsozJ39Is/maxresdefault.jpg",
    views: "271K",
    duration: "12:45",
  },
  {
    id: "l3",
    title: "KUGOOKIRIN G2 PRO - Street Beast Scooter",
    category: "Unboxing",
    embedUrl: "https://www.youtube.com/embed/z6kAORawg5k",
    thumbnail: "https://img.youtube.com/vi/z6kAORawg5k/maxresdefault.jpg",
    views: "150K+",
    duration: "16:22",
  },
  {
    id: "l4",
    title: "Coolest Car in the World! 2024",
    category: "Creative Ads",
    embedUrl: "https://www.youtube.com/embed/GJ-vyojX_6s",
    thumbnail: "https://img.youtube.com/vi/GJ-vyojX_6s/maxresdefault.jpg",
    views: "320K+",
    duration: "14:08",
  },
  {
    id: "l5",
    title: "iPhone 13 Pro - Gaming Experience",
    category: "Tech Reviews",
    embedUrl: "https://www.youtube.com/embed/UDxw6QFS_2k",
    thumbnail: "https://img.youtube.com/vi/UDxw6QFS_2k/maxresdefault.jpg",
    views: "180K+",
    duration: "10:30",
  },
  {
    id: "l6",
    title: "Samsung A55 - Full Review",
    category: "Tech Reviews",
    embedUrl: "https://www.youtube.com/embed/66YB9lC-yrI",
    thumbnail: "https://img.youtube.com/vi/66YB9lC-yrI/maxresdefault.jpg",
    views: "200K+",
    duration: "11:45",
  },
];

// Short-form content (YouTube Shorts / Instagram Reels style)
export const SHORT_VIDEOS = [
  {
    id: "s1",
    title: "iPhone 16 Pro Max - First Look",
    embedUrl: "https://www.youtube.com/embed/KPqBP0R-epU",
    thumbnail: "https://img.youtube.com/vi/KPqBP0R-epU/maxresdefault.jpg",
    views: "1.2M",
  },
  {
    id: "s2",
    title: "This Scooter is INSANE!",
    embedUrl: "https://www.youtube.com/embed/bobsozJ39Is",
    thumbnail: "https://img.youtube.com/vi/bobsozJ39Is/maxresdefault.jpg",
    views: "850K",
  },
  {
    id: "s3",
    title: "Tesla Model Y Hidden Features",
    embedUrl: "https://www.youtube.com/embed/GJ-vyojX_6s",
    thumbnail: "https://img.youtube.com/vi/GJ-vyojX_6s/maxresdefault.jpg",
    views: "2.1M",
  },
  {
    id: "s4",
    title: "Best Budget Phone 2025?",
    embedUrl: "https://www.youtube.com/embed/66YB9lC-yrI",
    thumbnail: "https://img.youtube.com/vi/66YB9lC-yrI/maxresdefault.jpg",
    views: "650K",
  },
  {
    id: "s5",
    title: "Unboxing the BEAST",
    embedUrl: "https://www.youtube.com/embed/z6kAORawg5k",
    thumbnail: "https://img.youtube.com/vi/z6kAORawg5k/maxresdefault.jpg",
    views: "430K",
  },
  {
    id: "s6",
    title: "iPhone vs Samsung - Quick Test",
    embedUrl: "https://www.youtube.com/embed/UDxw6QFS_2k",
    thumbnail: "https://img.youtube.com/vi/UDxw6QFS_2k/maxresdefault.jpg",
    views: "780K",
  },
  {
    id: "s7",
    title: "Gaming on iPhone 13 Pro",
    embedUrl: "https://www.youtube.com/embed/Cvqz4Qke_vM",
    thumbnail: "https://img.youtube.com/vi/Cvqz4Qke_vM/maxresdefault.jpg",
    views: "520K",
  },
  {
    id: "s8",
    title: "My YouTube Setup Tour",
    embedUrl: "https://www.youtube.com/embed/KPqBP0R-epU",
    thumbnail: "https://img.youtube.com/vi/KPqBP0R-epU/maxresdefault.jpg",
    views: "390K",
  },
];

export const PORTFOLIO_ITEMS = [
  {
    id: 1,
    title: "iPhone 17 Pro Max - All Features Revealed",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/KPqBP0R-epU",
    thumbnail: "https://img.youtube.com/vi/KPqBP0R-epU/hqdefault.jpg",
    views: "500K+",
    duration: "15:20",
    colSpan: "md:col-span-8",
  },
  {
    id: 2,
    title: "Best Electric Scooter in Egypt!",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/bobsozJ39Is",
    thumbnail: "https://img.youtube.com/vi/bobsozJ39Is/hqdefault.jpg",
    views: "271K",
    duration: "12:45",
    colSpan: "md:col-span-4",
  },
  {
    id: 3,
    title: "iPhone 13 Pro Gaming Experience",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/UDxw6QFS_2k",
    thumbnail: "https://img.youtube.com/vi/UDxw6QFS_2k/hqdefault.jpg",
    views: "180K+",
    duration: "10:30",
    colSpan: "md:col-span-4",
  },
  {
    id: 4,
    title: "Coolest Car in the World! 2024",
    category: "Creative Ads",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/GJ-vyojX_6s",
    thumbnail: "https://img.youtube.com/vi/GJ-vyojX_6s/hqdefault.jpg",
    views: "320K+",
    duration: "14:08",
    colSpan: "md:col-span-8",
  },
  {
    id: 5,
    title: "KUGOOKIRIN G2 PRO - Street Beast Scooter",
    category: "Unboxing",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/z6kAORawg5k",
    thumbnail: "https://img.youtube.com/vi/z6kAORawg5k/hqdefault.jpg",
    views: "150K+",
    duration: "16:22",
    colSpan: "md:col-span-6",
  },
  {
    id: 6,
    title: "Samsung A55 Full Review",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/66YB9lC-yrI",
    thumbnail: "https://img.youtube.com/vi/66YB9lC-yrI/hqdefault.jpg",
    views: "200K+",
    duration: "11:45",
    colSpan: "md:col-span-6",
  },
  {
    id: 7,
    title: "Tech Unboxing Special",
    category: "Unboxing",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/Cvqz4Qke_vM",
    thumbnail: "https://img.youtube.com/vi/Cvqz4Qke_vM/hqdefault.jpg",
    views: "95K+",
    duration: "8:30",
    colSpan: "md:col-span-4",
  },
  {
    id: 8,
    title: "iPhone 15 Pro Max - Worth the Upgrade?",
    category: "Tech Reviews",
    platform: "YouTube",
    embedUrl: "https://www.youtube.com/embed/GJ-vyojX_6s",
    thumbnail: "https://img.youtube.com/vi/GJ-vyojX_6s/hqdefault.jpg",
    views: "420K+",
    duration: "18:15",
    colSpan: "md:col-span-8",
  },
];

export const CATEGORIES = ["All", "Tech Reviews", "Unboxing", "Creative Ads", "Short-form"];

export const ACTIVE_GIVEAWAYS = [
  {
    id: 1,
    title: "iPhone 16 Pro Max Giveaway",
    image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=600&h=400&fit=crop",
    description: "Win a brand new iPhone 16 Pro Max in Desert Titanium! Follow the rules below to enter.",
    rules: [
      "Subscribe to the YouTube channel",
      "Like and comment on the giveaway video",
      "Follow on Instagram @georgeemad16",
      "Tag 2 friends in the comments",
    ],
    endDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(),
    prize: "iPhone 16 Pro Max",
  },
  {
    id: 2,
    title: "AirPods Pro 3 + Case",
    image: "https://images.unsplash.com/photo-1590658268037-6bf12f032f55?w=600&h=400&fit=crop",
    description: "Get a chance to win the latest AirPods Pro 3 with the premium case!",
    rules: [
      "Follow on TikTok @georgeemad17",
      "Share the giveaway video on your story",
      "Comment your favorite tech gadget",
    ],
    endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    prize: "AirPods Pro 3",
  },
];

export const PAST_GIVEAWAYS = [
  {
    id: 1,
    title: "Samsung Galaxy S25 Ultra",
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&h=400&fit=crop",
    winner: "Ahmed M.",
    date: "November 2025",
  },
  {
    id: 2,
    title: "MacBook Air M3",
    image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=600&h=400&fit=crop",
    winner: "Sara K.",
    date: "October 2025",
  },
  {
    id: 3,
    title: "Sony WH-1000XM5",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&h=400&fit=crop",
    winner: "Omar L.",
    date: "September 2025",
  },
];

export const SHOP_PRODUCTS = [
  {
    id: 1,
    title: "George Emad Signature Tee",
    price: "$35",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&h=625&fit=crop",
    buyUrl: "#",
  },
  {
    id: 2,
    title: "Tech Creator Hoodie",
    price: "$65",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=500&h=625&fit=crop",
    buyUrl: "#",
  },
  {
    id: 3,
    title: "Premium Phone Case",
    price: "$25",
    image: "https://images.pexels.com/photos/3981749/pexels-photo-3981749.jpeg?auto=compress&cs=tinysrgb&w=500&h=625&fit=crop",
    buyUrl: "#",
  },
  {
    id: 4,
    title: "Creator Essentials Cap",
    price: "$30",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c334e67a?w=500&h=625&fit=crop",
    buyUrl: "#",
  },
  {
    id: 5,
    title: "Tech Sticker Pack",
    price: "$12",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=500&h=625&fit=crop",
    buyUrl: "#",
  },
  {
    id: 6,
    title: "Limited Edition Mousepad",
    price: "$20",
    image: "https://images.pexels.com/photos/2453658/pexels-photo-2453658.jpeg?auto=compress&cs=tinysrgb&w=500&h=625&fit=crop",
    buyUrl: "#",
  },
];

export const ABOUT_DATA = {
  bio: "I'm George Emad, a passionate tech content creator and video producer. I've spent years perfecting the art of making technology accessible, exciting, and visually stunning for audiences across the globe.",
  journey: [
    { year: "2019", milestone: "Started creating tech content on YouTube" },
    { year: "2020", milestone: "Reached 10K subscribers, first brand deal" },
    { year: "2021", milestone: "Expanded to TikTok and Instagram Reels" },
    { year: "2022", milestone: "Hit 100K followers across platforms" },
    { year: "2023", milestone: "First viral video - 5M+ views" },
    { year: "2024", milestone: "Launched YouTube Shorts channel" },
    { year: "2025", milestone: "400K+ total audience, premium brand partnerships" },
  ],
  platforms: [
    { name: "YouTube", description: "Long-form tech reviews & deep dives", icon: "youtube" },
    { name: "YouTube Shorts", description: "Quick tech tips & highlights", icon: "youtube" },
    { name: "TikTok", description: "Viral short-form tech content", icon: "tiktok" },
    { name: "Instagram", description: "Reels, stories & behind the scenes", icon: "instagram" },
  ],
  style: "My content blends cinematic visuals with honest, detailed tech analysis. Every video is crafted to deliver both entertainment and genuine value, whether it's a 20-minute review or a 30-second short.",
  portrait: "https://images.pexels.com/photos/9200331/pexels-photo-9200331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
